// The journey runs inside the publisher's iframe, where browsers block a
// cross-origin frame from navigating the top window and block popups that
// are not opened during a user gesture. So the provider tab is opened
// synchronously on the tap of the provider button, holds a "getting ready"
// message, and is sent to the provider once the link exists.

export const CHOICE_TO_PROVIDER = {
  bankid_cz: "BANKID_CZ",
  bankid_se: "BANKID_SE",
  bankid_no: "BANKID_NO",
  finnish_trust_network: "FINNISH_TRUST_NETWORK",
  mojeid: "MOJEID",
};

let providerTab = null;

const escapeHtml = (s) =>
  String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const holdingPage = (message, accent) => `<!doctype html>
<html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">
<title>${escapeHtml(message)}</title>
<style>
  html,body{height:100%;margin:0;background:#fff;color:#1a1b1e;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif}
  .wrap{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:24px;padding:20px;box-sizing:border-box}
  .disc{width:88px;height:88px;border-radius:50%;background:${escapeHtml(accent)};display:flex;align-items:center;justify-content:center;box-shadow:0 6px 22px ${escapeHtml(accent)}40;animation:in .6s cubic-bezier(.34,1.56,.64,1) both}
  .disc svg{width:38px;height:38px;stroke:#fff;fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
  p{margin:0;font-size:19px;font-weight:600;text-align:center}
  @keyframes in{from{transform:scale(.55);opacity:0}to{transform:scale(1);opacity:1}}
  @media (prefers-color-scheme:dark){html,body{background:#1a1b1e;color:#f1f3f5}}
</style></head>
<body><div class="wrap"><div class="disc"><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg></div><p>${escapeHtml(message)}</p></div></body></html>`;

/**
 * Open the provider tab during a user gesture. Returns the window handle, or
 * null if the browser blocked it (then the start screen shows a button).
 */
export const openProviderTab = ({ providerName, requestId, message, accent = "#0075c0" }) => {
  if (typeof window === "undefined") return null;
  // What TrinsicStart stores before navigating; set now so the new tab's copy
  // of sessionStorage has them for the return page.
  try {
    sessionStorage.setItem("trinsic_provider", providerName);
    if (requestId) sessionStorage.setItem("edge_request_id", requestId);
  } catch (e) {
    /* storage unavailable */
  }
  let tab = null;
  try {
    tab = window.open("", "_blank");
  } catch (e) {
    tab = null;
  }
  if (!tab) return null;
  try {
    tab.document.open();
    tab.document.write(holdingPage(message || "Getting your verification ready…", accent));
    tab.document.close();
  } catch (e) {
    /* still usable for navigation */
  }
  providerTab = tab;
  return tab;
};

/** The tab opened on the tap, if it is still open. */
export const getProviderTab = () => {
  if (providerTab && !providerTab.closed) return providerTab;
  providerTab = null;
  return null;
};

/** Point the held tab at the provider. Returns false if there is no usable tab. */
export const sendProviderTabTo = (url) => {
  const tab = getProviderTab();
  if (!tab) return false;
  try {
    tab.location.href = url;
    try {
      tab.focus();
    } catch (e) {
      /* focus can be refused */
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const clearProviderTab = () => {
  providerTab = null;
};
